import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HelloSignService } from '../../shared/hello-sign.service';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { HelloSignConfig } from '../../shared/contract.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-hello-sign',
  templateUrl: './hello-sign.component.html',
  styleUrls: ['./hello-sign.component.scss']
})
export class HelloSignComponent implements OnInit, OnDestroy {
  helloSignForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading = false;
  originalFormValue: any = null;
  hasChanges = false;
  private formSubscription: Subscription;
  hideApiKey = true;

  constructor(
    private formBuilder: FormBuilder,
    private helloSignService: HelloSignService,
    private toast: ToastrService
  ) {
    this.helloSignForm = this.formBuilder.group({
      apiKey: ['', [Validators.required]],
      clientId: ['', [Validators.required]]
    });

    // Subscribe to form value changes
    this.formSubscription = this.helloSignForm.valueChanges.subscribe(() => {
      this.checkFormChanges();
    });
  }

  ngOnInit() {
    this.loadConfig();
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  private checkFormChanges() {
    if (!this.originalFormValue) {
      this.hasChanges = false;
      return;
    }
    
    const currentValue = this.helloSignForm.value;
    this.hasChanges = Object.keys(currentValue).some(key => 
      currentValue[key] !== this.originalFormValue[key]
    );
  }

  loadConfig() {
    this.isLoading = true;
    this.helloSignService.getConfig().subscribe({
      next: (response: any) => {
        if (response && response.isSuccess && response.body) {
          try {
            const config = response.body;
            const formValue = {
              apiKey: config.apiKey || '',
              clientId: config.clientId || ''
            };
            
            this.helloSignForm.setValue(formValue);
            this.originalFormValue = { ...formValue };
            this.hasChanges = false;
          } catch (err) {
            this.toast.error('Error loading configuration');
          }
        } else {
          this.toast.warning('No configuration found');
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.toast.error('Failed to load Hello Sign configuration');
        this.isLoading = false;
      }
    });
  }

  onSubmit() {
    if (this.helloSignForm.valid && this.hasChanges) {
      this.isLoading = true;
      this.helloSignService.saveConfig(this.helloSignForm.value).subscribe({
        next: () => {
          this.toast.success('Hello Sign configuration saved successfully');
          this.originalFormValue = { ...this.helloSignForm.value };
          this.hasChanges = false;
          this.isLoading = false;
        },
        error: (error) => {
          if(error.status === 409){
            this.toast.error('Hello Sign configuration already exists');
          }else{
            this.toast.error('Failed to save Hello Sign configuration');
          }
          this.isLoading = false;
        }
      });
    }
  }

  resetForm() {
    if (this.originalFormValue) {
      this.helloSignForm.setValue(this.originalFormValue);
    } else {
      this.helloSignForm.reset();
    }
    this.hasChanges = false;
  }

  toggleApiKeyVisibility() {
    this.hideApiKey = !this.hideApiKey;
  }
}
